export default __webpack_public_path__ + "static/media/img-0119-france-full-face.c2e2e825.png";